//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WheelBet from './Bet.vue';
import { WHEEL_MULTIPLIERS } from '../wheel.entity';

export default {
  name: 'GameColor',
  components: {
    WheelBet
  },
  props: {
    color: {
      type: Object,
      default: () => ({ bets: [], totalBankUsd: 0, usersCount: 0 })
    },
    multiplier: {
      type: [Number, String],
      required: true
    },
    winMultiplier: {
      type: [Number, String],
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    settingsState: {
      type: Object,
      default: () => ({ streamerMode: false })
    }
  },
  computed: {
    multiplierClass() {
      const val = WHEEL_MULTIPLIERS ? WHEEL_MULTIPLIERS[this.multiplier] : this.multiplier;
      return String(val).toLowerCase();
    },
    displayMultiplier() {
      return WHEEL_MULTIPLIERS ? WHEEL_MULTIPLIERS[this.multiplier] : this.multiplier;
    },
    sortedBets() {
      if (!this.color || !Array.isArray(this.color.bets)) {
        return [];
      }
      return [...this.color.bets].sort((a, b) => {
        const totalDiff = (b.itemsTotal || 0) - (a.itemsTotal || 0);
        if (totalDiff !== 0) return totalDiff;
        return Number(Boolean(b.isOwn)) - Number(Boolean(a.isOwn));
      });
    }
  },
  methods: {
    formatNumber(val) {
      if (val === undefined || val === null) return '0';
      return val.toLocaleString();
    },
    formatCurrency(val) {
      if (val === undefined || val === null) return '0.00';
      return Number(val).toFixed(2);
    }
  }
};
